/* eslint-disable react/prop-types */
function ArrowTwoIcon({ className, fill = "#000000", size = "24px", direction = "right" }) {
  // Map directions to rotation angles
  const rotations = {
    right: "rotate(0deg)",
    left: "rotate(180deg)",
    top: "rotate(270deg)",
    bottom: "rotate(90deg)",
  };

  return (
    <svg
      className={className}
      fill={fill}
      height={size}
      width={size}
      viewBox="0 0 512 512"
      xmlSpace="preserve"
      style={{ transform: rotations[direction] }} // Apply rotation
    >
      <g strokeWidth="0"></g>
      <g strokeLinecap="round" strokeLinejoin="round"></g>
      <g>
        <g>
          <g>
            <g>
              <path d="M256,5.333C114.88,5.333,0,117.76,0,256s114.88,250.667,256,250.667S512,394.24,512,256S397.12,5.333,256,5.333z M256,485.333C126.613,485.333,21.333,382.4,21.333,256S126.613,26.667,256,26.667S490.667,129.493,490.667,256 S385.387,485.333,256,485.333z"></path>
              <path d="M369.28,247.467l-181.653-133.44c-4.693-3.627-11.307-2.773-14.933,1.92c-3.627,4.693-2.773,11.307,1.92,14.933 c0.107,0.107,0.32,0.213,0.427,0.32L344.96,256L175.04,380.693c-4.8,3.52-5.76,10.133-2.24,14.933 c3.52,4.8,10.133,5.76,14.933,2.24L369.387,264.64c4.8-3.52,5.76-10.133,2.24-14.933 C370.88,248.853,370.133,248.107,369.28,247.467z"></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

export default ArrowTwoIcon;
